import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';

const ProductViewToggle = ({ view, onToggle }) => {
    return (
        <div style={{ margin: '6px 5px 6px 0px' }}>
            <Tooltip title="Grid View">
                <IconButton onClick={() => onToggle('grid')} color={view === 'grid' ? 'primary' : 'default'}>
                    <GridViewIcon sx={{fontSize: { xs: 27, sm: 23,},}} />
                </IconButton>
            </Tooltip>

            <Tooltip title="List View">
                <IconButton onClick={() => onToggle('list')} color={view === 'list' ? 'primary' : 'default'}>
                    <ViewListIcon sx={{fontSize: { xs: 27, sm: 23,},}}/>
                </IconButton>
            </Tooltip>
        </div>
    );
};

export default ProductViewToggle;
